import styles from "./CompanyAssessments.module.css";

interface ScaleAnswerFieldProps {
    groupName: string;
    min: number;
    max: number;
    minLabel?: string;
    maxLabel?: string;
    value: number | undefined;
    onChange: (value: number) => void;
    disabled?: boolean;
}

export function ScaleAnswerField({
    groupName,
    min,
    max,
    minLabel,
    maxLabel,
    value,
    onChange,
    disabled = false
}: ScaleAnswerFieldProps) {
    const values: number[] = [];
    for (let i = max; i >= min; i -= 1) {
        values.push(i);
    }

    return (
        <div className={styles.scaleAnswer}>
            {maxLabel ? <div className={styles.scaleLabel}>{maxLabel}</div> : null}
            {values.map(scaleValue => (
                <label key={scaleValue} className={styles.scaleOption}>
                    <input
                        type="radio"
                        name={groupName}
                        value={scaleValue}
                        checked={value === scaleValue}
                        disabled={disabled}
                        onChange={() => onChange(scaleValue)}
                    />
                    <span>{scaleValue}</span>
                </label>
            ))}
            {minLabel ? <div className={styles.scaleLabel}>{minLabel}</div> : null}
        </div>
    );
}
